module.exports = __webpack_public_path__ + "static/media/nucleus-icon.497bb5af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/system/assets/images/nucleus-icon.svg
// module id = 1095
// module chunks = 0